import { useQuery } from '@tanstack/react-query'

import { fetchDashboard } from '@/api/dashboard'

export function useDashboard(orgId: number | null | undefined) {
  return useQuery({
    queryKey: ['dashboard', orgId],
    queryFn: () => fetchDashboard(orgId!),
    enabled: !!orgId,
    staleTime: 15_000,
  })
}
